type Address = { street: string; zipcode: number };

// Keep this normalization aligned with MemberController.cleanAddressString.
const cleanStreet = (street: string) =>
  (street || "")
    .replace(/ /g, "")
    .replace(/\./g, "")
    .replace(/vägen/g, "v")
    .replace(/gatan/g, "g")
    .toLowerCase();

export const matchesClubAddress = (member: Address, club: Address) =>
  member.zipcode === club.zipcode &&
  cleanStreet(member.street) === cleanStreet(club.street);
